import React from "react";
var __jsx = React.createElement;
import ContactUsForm from './ContactUsForm';
function ContactUsFormAdapter(_ref) {
  var entry = _ref.entry;
  return __jsx(ContactUsForm, {
    contactUsData: entry
  });
}
export default ContactUsFormAdapter;